import { render, staticRenderFns } from "./ElementNameNoDescTableColumn.vue?vue&type=template&id=ee552f7a&scoped=true"
import script from "./ElementNameNoDescTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementNameNoDescTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementNameNoDescTableColumn.vue?vue&type=style&index=0&id=ee552f7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee552f7a",
  null
  
)

export default component.exports